import { FontSizes, IStackTokens, NeutralColors, Stack } from "@fluentui/react"
import { IRegion } from "../../../../Interfaces/estadoEquipos/IEstadoEquipo"
import COLORES from "../../../../utils/theme/colores"
import { index } from "d3";
import { AccordionItem } from "../../../../components/accordionItem/AccordionItem";
import { EquipoComponent } from "./EquipoComponent";
import { EquiposComponent } from "./EquiposComponent";


interface IRegionComponent{
    region:IRegion
}
const accordionTokens: IStackTokens = { childrenGap: 10 };
export const RegionComponent=(props:IRegionComponent)=>{
    return(
        <div style={{
        borderRadius: '8px',
        backgroundColor: COLORES.Bases.BackgroundNavOutlook,
        padding: 16,
        maxWidth: 300,
       }}>
       <div style={{color: NeutralColors.gray130, fontSize: FontSizes.size20, textAlign:'center'}}>
      {props.region.region}
      </div>
      <br/>
      <Stack tokens={accordionTokens} styles={{ root: { maxWidth: 400 } }}>
        {props.region.informacion.map((item,index)=>(
         <AccordionItem value={index.toString()} header={item.tipoEquipo} key={index}>
            <EquiposComponent data={item.data}/>
         </AccordionItem>
        ))}
      </Stack>

        </div>
    )
}